import {
  OEText,
  border,
  borderColor,
  flex,
  height,
  mt,
  width,
} from '@openeducation/oe-it-components';
import {
  dateArrayToString,
  FeedbackResponseDTO,
} from '@openeducation/oe-it-services';
import { secondaryFontFamily, styled } from '@openeducation/oe-it-themes';
import React from 'react';
import { View } from 'react-native';
import { useTheme } from 'react-native-paper';

interface PCFeedbackCardTitleProps {
  feedback: FeedbackResponseDTO;
}

export const PCFeedbackCardTitle = ({ feedback }: PCFeedbackCardTitleProps) => {
  const { colors } = useTheme();
  const { dateOfClass, teacherName, repeatingLesson = false } = feedback;

  return (
    <View style={[flex('flex-row', 'justify-content-between')]}>
      <View style={[flex('flex-row')]}>
        <OEText fontFamily={secondaryFontFamily} fontType="regular">
          {dateArrayToString(dateOfClass, 'MMM, dd yyyy - h:mm a')}
        </OEText>
        <View
          style={[
            borderColor(colors.dark2),
            { transform: [{ rotate: '90deg' }] },
            mt(10),
            height(0),
            width(25.2),
            border('solid', 1),
          ]}
        />
        <OEText fontFamily={secondaryFontFamily} fontType="bold">
          {teacherName}
        </OEText>
      </View>
      {repeatingLesson && <RepeatClassBadge>Repeat class</RepeatClassBadge>}
    </View>
  );
};

const RepeatClassBadge = styled(OEText).attrs(({ theme }) => ({
  color: theme.color.white,
  fontSize: 12,
  lineHeight: 14.5,
}))`
  background-color: ${({ theme }) => theme.color.accent};
  padding: 4px 8px;
  border-radius: 4px;
  text-transform: uppercase;
`;
